/** @file Bone timelines of one animation: numeric channels (setup-relative) and inherit codes. */
import type { AnimationDoc, TimelineJson } from '@pose2d/format/types';
import { byCompiledIndex } from './byCompiledIndex';
import { COMPILE_CODES } from './compileCodes';
import { curvedTimeline } from './curvedTimeline';
import { discreteTimeline } from './discreteTimeline';
import { hasKeys } from './hasKeys';
import { requireCompiledIndex } from './requireCompiledIndex';

const NUMERIC = ['rotation', 'x', 'y', 'scaleX', 'scaleY', 'shearX', 'shearY'] as const;
const same = (v: number): number => v;

/** Per keyed bone (compiled bone order): rotation, x, y, scaleX, scaleY, shearX, shearY, then inherit. */
export function boneTimelines(anim: AnimationDoc, fps: number, boneIndex: ReadonlyMap<string, number>, at: string): TimelineJson[] {
  const out: TimelineJson[] = [];
  for (const [id, tl] of byCompiledIndex(anim.bones, boneIndex)) {
    const bone = requireCompiledIndex(boneIndex, id, 'bone', `${at}.bones.${id}`);
    for (const k of NUMERIC) {
      const keys = tl[k];
      if (hasKeys(keys)) out.push({ k, bone, ...curvedTimeline(keys, fps, same) });
    }
    if (hasKeys(tl.inherit)) out.push({ k: 'inherit', bone, ...discreteTimeline(tl.inherit, fps, (v) => COMPILE_CODES.inherit[v]) });
  }
  return out;
}
